// extracted by mini-css-extract-plugin
export default {"base":"vp_solti","content":"vp_Thtkt","icon":"vp_o9mGo","label":"vp_a4lbb"};